export default __webpack_public_path__ + "static/media/phantom.a6d53c60.png";